<template>
  <a-drawer
    title="Nastavení šablony"
    placement="right"
    :closable="true"
    @close="onClose"
    :visible="settings.isSettingsOpen"
    :zIndex="1010"
  >
    <div :class="$style.description">
      Nastavte si vzhled šablony.
    </div>
    <div :class="$style.item">
      <a-switch :checked="settings.isMenuTop" @click="settingChange($event, 'isMenuTop')"/>
      <span :class="$style.itemLabel">Horní menu (Vodorovně)</span>
    </div>
    <div :class="$style.item">
      <a-switch
        :checked="settings.isMenuCollapsed"
        @click="settingChange($event, 'isMenuCollapsed')"
      />
      <span :class="$style.itemLabel">Zmenšené menu</span>
    </div>
    <div :class="$style.item">
      <a-switch :checked="settings.isMenuShadow" @click="settingChange($event, 'isMenuShadow')"/>
      <span :class="$style.itemLabel">Menu vrhá stín</span>
    </div>
    <div :class="$style.item">
      <a-switch :checked="settings.isLightTheme" @click="settingChange($event, 'isLightTheme')"/>
      <span :class="$style.itemLabel">Světlé menu</span>
    </div>
    <div :class="$style.item">
      <a-switch :checked="settings.isBorderless" @click="settingChange($event, 'isBorderless')"/>
      <span :class="$style.itemLabel">Bezokrajové karty</span>
    </div>
    <div :class="$style.item">
      <a-switch
        :checked="settings.isSquaredBorders"
        @click="settingChange($event, 'isSquaredBorders')"
      />
      <span :class="$style.itemLabel">Hranaté okraje</span>
    </div>
    <div :class="$style.item">
      <a-switch :checked="settings.isFixedWidth" @click="settingChange($event, 'isFixedWidth')"/>
      <span :class="$style.itemLabel">Pevná šířka</span>
    </div>
  </a-drawer>
</template>

<script>
export default {
  name: 'cui-settings',
  props: {
    settings: Object,
  },
  methods: {
    onClose() {
      const isSettingsOpen = this.settings.isSettingsOpen
      this.$store.commit('CHANGE_SETTING', { setting: 'isSettingsOpen', value: !isSettingsOpen })
    },
    settingChange(e, setting) {
      const value = !this.settings[setting]
      this.$store.commit('CHANGE_SETTING', { setting, value })
    },
  },
}
</script>

<style lang="scss" module>
@import "@/assets/styles/mixins.scss";

.description {
  font-size: 12px;
  margin-bottom: rem(20);
  color: $text-lighten;
}

.item {
  margin-bottom: rem(15);
}

.itemLabel {
  position: relative;
  top: 2px;
  margin-left: 10px;
}
</style>
